// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"378":"PublicLayout","621":"TaskAreaBoard","835":"GeneralView"}[chunkId] + "." + {"378":"ee68521e","621":"35b4d231","835":"349d8f97"}[chunkId] + ".css";
};